import * as React from "react"
import request from "@/server/request"
import config, { captchaAppId } from "@/server/config"
import alert from "@/pages/components/common/alert"
import "./scss/form.scss"

interface initProps {
	history: any
}

class ReplacePhone extends React.Component<initProps, any> {
	constructor(props: any) {
		super(props)
		this.state = {
			imgCode: "",
			form: {
				phone: "",
				code: "",
			},
			captchakey: "", // 验证码随机数
			captchaUrl: "", // 图形验证码地址
			timer: "", // 定时器
			timerNumber: 60, //
			isOpenTimer: true,
			isSubmit: false,
		}
	}

	componentDidMount() {
		// this.getGraphic();

		function GetQueryString(name: any) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
			var r = window.location.search.substr(1).match(reg)
			if (r != null) return unescape(r[2])
			return null
		}
		const phone = GetQueryString("phone")
		this.setState({
			form: {
				...this.state.form,
				phone: phone ? phone : "",
			},
		})
	}

	render() {
		return (
			<div className="page-replacePhone gray-bg">
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label">手机号码</label>
						<input
							disabled={true}
							type="text"
							placeholder="请输入手机号码"
							value={this.state.form.phone}
							onChange={(e: any) => this.setForm("phone", e.target.value)}
						/>
					</div>
					{/*<div className="form-input-warrper code-warpper-form">
						<label className="label">图形验证码</label>
						<input type="text"   placeholder="请输入图形验证码" value={this.state.imgCode} onChange={ (e:any) => this.setState({ imgCode: e.target.value }) }   className="login-input" />
						<img src={this.state.captchaUrl} alt="" className="code-img" onClick={() => this.getGraphic()}/>
					</div>*/}
					<div className="form-input-warrper code">
						<label className="label">短信验证码</label>
						<input
							type="text"
							placeholder="请输入验证码"
							className="code-input"
							value={this.state.form.code}
							onChange={(e: any) => this.setForm("code", e.target.value)}
						/>
						<button
							type="button"
							className="code-btn"
							onClick={() => this.sendMessage()}
						>
							{this.state.timerNumber === 60
								? "获取验证码"
								: this.state.timerNumber}
						</button>
					</div>
				</div>

				<div className="form-btn-warrrper">
					<button className="form-btn" onClick={() => this.submitForm()}>
						下一步
					</button>
				</div>
			</div>
		)
	}

	// 获取验证码
	// private getGraphic() {
	// 	const text = Math.random() * Math.pow(10,17);
	// 	const url = config.WAPAPI + 'captcha/image?captchakey=' + text;

	// 	this.setState({
	// 		captchaUrl: url,
	// 		captchakey: text,
	// 	})
	// }

	// 表单赋值
	private setForm(name?: string, val?: any) {
		if (!name) {
			return
		}
		this.state.form[name] = val
		this.setState({
			form: {
				...this.state.form,
			},
		})
	}

	// 发送短信
	private sendMessage() {
		const that = this

		if (!this.state.isOpenTimer) {
			return
		}
		if (this.state.form.phone.replace(/\s/gi, "") === "") {
			alert.open({
				promptText: "请输入手机号",
			})
			return
		}
		// if (this.state.imgCode.replace(/\s/gi, "") === "") {
		// 	alert.open({
		// 		promptText: "请输入图形验证码",
		// 	})
		// 	return
		// }

		// 定义回调函数
		function callback(res: any) {
			// 第一个参数传入回调结果，结果如下：
			// ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
			// ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
			// CaptchaAppId       String    验证码应用ID。
			// bizState    Any       自定义透传参数。
			// randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
			// verifyDuration     Int   验证码校验接口耗时（ms）。
			// actionDuration     Int   操作校验成功耗时（用户动作+校验完成）(ms)。
			// sid     String   链路sid。
			// res（用户主动关闭验证码）= {ret: 2, ticket: null}
			// res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
			// res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
			// 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
			if (typeof res.errorCode === "undefined" && res.randstr && res.ticket) {
				that.startSendSms(res.randstr, res.ticket)
			}
		}
		function loadErrorCallback() {
			var appid = captchaAppId
			var ticket =
				"trerror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000)
			callback({
				ret: 0,
				randstr: "@" + Math.random().toString(36).substr(2),
				ticket: ticket,
				errorCode: 1001,
				errorMessage: "jsload_error",
			})
		}

		try {
			var captcha = new (window as any).TencentCaptcha(captchaAppId, callback, {
				userLanguage: "zh-cn",
				showFn: () => {},
			})
			captcha.show()
		} catch (error) {
			loadErrorCallback()
		}
	}

	private startSendSms(randstr: any, ticket: string) {
		const that = this
		this.setState(
			{
				isOpenTimer: false,
			},
			() => {
				const data = request({
					method: "get",
					url: `${config.API2}sms/send`,
					data: {
						type: 3,
						mobile: this.state.form.phone,
						randstr,
						ticket,
					},
				})

				data.then((r) => {
					if (r.code === 1) {
						// 如果成功 开启定时器

						that.setState({
							timer: setInterval(() => {
								if (that.state.timerNumber > 0) {
									that.setState({
										timerNumber: this.state.timerNumber - 1,
									})
								} else {
									//  重置定时器
									clearInterval(this.state.timer)
									// that.getGraphic()
									that.setState({
										isOpenTimer: true,
										timer: "",
										timerNumber: 60,
									})
								}
							}, 1000),
						})
					} else {
						// that.getGraphic()
						that.setState(
							{
								isOpenTimer: true,
							},
							() => {
								alert.open({
									promptText: r.msg,
								})
							}
						)
					}
				})
			}
		)
	}

	// 检查表单
	private checkForm() {
		if (this.state.form.code.replace(/\s/gi, "") === "") {
			alert.open({
				promptText: "请输入验证码",
			})

			return
		}
		if (this.state.form.phone.replace(/\s/gi, "") === "") {
			alert.open({
				promptText: "请输入手机号",
			})
			return
		}
		return true
	}

	// 提交表单
	private async submitForm() {
		const that = this
		if (!this.state.isSubmit) {
			if (!this.checkForm()) {
				return
			}
			// 防止重复提交
			this.setState({
				isSubmit: true,
			})
			const r = await request({
				method: "post",
				url: `${config.API}sms/valid`,
				data: {
					mobile: this.state.form.phone,
					code: this.state.form.code,
				},
			})
			that.setState(
				{
					isSubmit: false,
				},
				() => {
					if (r.code !== 1) {
						alert.open({
							promptText: r.msg,
						})
					} else {
						that.setState(
							{
								form: {
									phone: "",
									code: "",
								},
							},
							() => that.props.history.push("/replace_phone2")
						)
					}
				}
			)
		}
	}
}

export default ReplacePhone
